import http from '@/utils/http'

export default {
  // 获取律师详情接口
  getLawyerDetail (params) {
    return http.get(`/promotion/v1/api/lawyer/review/${params}`)
  }
}



// WEBPACK FOOTER //
// ./src/components/lawyer-detail/api/index.js